/**
 * BabyBjörn product row — Splide carousel.
 * Desktop: 4 full cards + a ~20% peek of the next product, inside the page-width.
 * Tablet/mobile: fewer per page with a peek of the next card.
 */
(function () {
  // The complement row ("Perfect to match with") reuses this carousel with its
  // own BEM prefix, so match both splide elements and both wrapper roots.
  const ROOT_SELECTOR = '.babybjorn-product-slider__splide, .babybjorn-product-complement__splide';
  const WRAP_SELECTOR = '.babybjorn-product-slider, .babybjorn-product-complement';

  function getSplideOptions(el) {
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    var padKey = rtl ? 'left' : 'right';
    var isComplement = el && el.classList.contains('babybjorn-product-complement__splide');
    // Peeks use trailing padding (a % of the track) instead of a fractional
    // perPage, which Splide rounds inaccurately. On desktop 6.2% of the track
    // ≈ a 20% sliver of the next card, with 4 full cards at ~296px (≈ UK width),
    // all inside the page-width — no edge bleed.
    var peekLg = {};
    peekLg[padKey] = '6.2%';
    var peekMd = {};
    peekMd[padKey] = '6%';
    // Mobile: 1 full card + a ~25% peek of the next (1.25 products visible).
    // With perPage 1, the card fills (track − padding), so 20% trailing padding
    // ≈ a quarter-card sliver: 0.25 × (track − 0.2·track) = 0.2 × track.
    // Complement row shows just a 10% sliver of the next card on mobile.
    var peekSm = {};
    peekSm[padKey] = isComplement ? '10%' : '20%';
    return {
      type: 'slide',
      direction: rtl ? 'rtl' : 'ltr',
      perPage: 4,
      perMove: 1,
      gap: '2.4rem',
      padding: peekLg,
      pagination: false,
      arrows: false,
      drag: true,
      rewind: false,
      speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400,
      breakpoints: {
        989: {
          perPage: 2.5,
          padding: peekMd,
          gap: '1rem',
        },
        749: {
          perPage: 1,
          padding: peekSm,
          gap: '0.65rem',
        },
      },
    };
  }

  function syncArrows(splide, prevBtn, nextBtn) {
    if (!splide || !splide.Components || !splide.Components.Controller) return;
    let end = 0;
    try {
      end = splide.Components.Controller.getEnd();
    } catch (e) {
      return;
    }
    const i = splide.index;
    if (prevBtn) {
      prevBtn.disabled = i <= 0;
    }
    if (nextBtn) {
      nextBtn.disabled = i >= end;
    }
  }

  function mountSplide(el) {
    if (!el || el.dataset.bbjSplideReady === '1') return;
    if (typeof Splide === 'undefined') return;

    const root = el.closest(WRAP_SELECTOR);
    const prevBtn = root && root.querySelector('[data-bbj-ps-prev]');
    const nextBtn = root && root.querySelector('[data-bbj-ps-next]');

    const splide = new Splide(el, getSplideOptions(el));
    splide.mount();
    el._babybjornSplide = splide;
    el.dataset.bbjSplideReady = '1';

    function refreshLayout() {
      try {
        splide.refresh();
      } catch (e) {
        /* noop */
      }
    }

    /* One sync refresh right after mount — avoids a second layout frame from rAF / moved. */
    refreshLayout();

    const onPrev = function (e) {
      e.preventDefault();
      splide.go('<');
    };
    const onNext = function (e) {
      e.preventDefault();
      splide.go('>');
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', onPrev);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', onNext);
    }

    const update = function () {
      syncArrows(splide, prevBtn, nextBtn);
    };
    splide.on('mounted moved resized updated', update);
    update();

    el._babybjornSplideCleanup = function () {
      if (prevBtn) prevBtn.removeEventListener('click', onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      splide.destroy();
      delete el._babybjornSplide;
      delete el._babybjornSplideCleanup;
      delete el.dataset.bbjSplideReady;
    };
  }

  function destroySplideIn(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(ROOT_SELECTOR).forEach(function (el) {
      if (el._babybjornSplideCleanup) {
        el._babybjornSplideCleanup();
      }
    });
  }

  function mountAll(root) {
    root.querySelectorAll(ROOT_SELECTOR).forEach(mountSplide);
  }

  function scheduleMount(root) {
    var target = root || document;
    queueMicrotask(function () {
      if (typeof Splide === 'undefined') {
        requestAnimationFrame(function () {
          if (typeof Splide !== 'undefined') {
            mountAll(target);
          }
        });
        return;
      }
      mountAll(target);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleMount(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      scheduleMount(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target) {
      destroySplideIn(event.target);
    }
  });
})();
